import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    [&>svg]:w-8
  `,
  variants: {
    social: {
      twitter: `
      text-product-twitter
    `,
      facebook: `
      text-product-facebook
    `,
    },
  },
});
